
export const SET_MSG = 'TABELAPRECO_MSG';
export const SET_EDITAR = 'TABELAPRECO_EDITAR';
export const SET_LISTA = 'TABELAPRECO_LISTA';
export const SET_PESQUISA = 'TABELAPRECO_PESQUISA';
export const SET_MATRICULA = 'TABELAPRECO_MATRICULA';